import { createSlice } from "@reduxjs/toolkit";

export const kbPagesSlice = createSlice({
  name: "kbPages",
  initialState: {
    getKbPagesResult: false,
    getKbPagesLoading: false,
    getKbPagesError: false,
    addKbPagesResult: false,
    addKbPagesLoading: false,
    deleteKbPagesResult: false,
  },
  reducers: {
    kbPagesReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_KBPAGES":
          return {
            ...state,
            getKbPagesResult: payload.data,
            getKbPagesLoading: payload.loading,
            getKbPagesError: payload.error,
          };
        case "ADD_KBPAGES":
          return {
            ...state,
            addKbPagesResult: payload.data,
            addKbPagesLoading: payload.loading,
          };
        case "DELETE_KBPAGES":
          return {
            ...state,
            deleteKbPagesResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { kbPagesReducers } = kbPagesSlice.actions;

export default kbPagesSlice.reducer;
